export default {
  section: 'Producción',
  loading: 'Cargando subrecetas',
  headers: {
    name: 'Nombre',
    production: 'Cantidad producida',
    cost: 'Costo',
    unitCost: 'Costo unitario'
  },
  labels: {
    production: 'Cantidad producida',
    unit: 'Unidad de almacenaje'
  }
}
